var render = function render(){var _vm=this,_c=_vm._self._c;return _c('legal-page-layout',{attrs:{"title":_vm.$t('cookies.title'),"updated":_vm.$t('cookies.updated'),"paragraphs":_vm.$t('cookies.paragraphs')}})
}
var staticRenderFns = []

export { render, staticRenderFns }